/* eslint max-len: 0 */
import Enum from 'enum';

/**
 * Enum defining all available api v2 for "payments and billing" resources and their URL template
 */
export const Resources = new Enum({
  AccountBankInfo: 'account/bank_info',
  AccountBankInfoDelete: 'users/account/delete_bank_account',
  AccountPaymentMethod: 'account/payment_method',
  UserBankInfo: 'users/:userId/account/bank_info',
  UserPaymentMethodChangesHistory: 'user/:userId/payment_method/history',
  UserAccounts: 'user/:userId/accounts',

  // Branch
  BranchWalletStatus: 'branch/wallet_status',
  BranchDirectDebitStatus: 'branch/direct_debit_status',
  BranchWalletInfo: 'branch/wallet_info',
  BranchWallet: 'branch/wallet',
  BranchDirectDebit: 'branch/direct_debit',
  BranchUserPaymentMethod: 'branch/user/payment_method',
  BranchPaymentRetry: 'branch/payment/retry',
  BranchWalletInternalStatus: 'branch/wallet/user/:userId/wallet_internal_status',
  BranchWalletResetUser: 'branch/wallet/user/:userId/reset',
  // ~Branch

  // Plaid
  PlaidLinkCreate: 'plaid/link/create',
  PlaidLinkSuccess: 'plaid/link/success',
  PlaidIdvToken: 'plaid/link/idv/token',
  PlaidIdvGet: 'plaid/link/idv/get',
  // ~Plaid

  // Simulate Plaid Flow
  SimulatePlaidFlow: 'simulation/simulate_plaid_flow',
  // ~Simulate

  //Provider
  CalculateAdjustments: 'calculate_adjustments',
  SaveResolution: 'save_resolution',
  //Ledger
  ProviderDigitalInvoiceHistory: 'user/invoice',
  PastInvoices: 'past_invoices',

  // User Search
  UserSearchMpy: 'users/search',

  // Paid Mpy
  PaidMpyExport: 'payable/paid/export',
  PaidMpy: 'payable/paid',
  PaidMpySummary: 'payable/paid/summary',
  PaidMpyEntries: 'payable/paid/:id/entries',

  // Unpaid Mpy
  UnpaidMpy: 'payable/unpaid',
  UnpaidMpySummary: 'payable/unpaid/summary',
  UnpaidMpyEntries: 'payable/unpaid/:id/entries',
});
